import { ContentHubObjectSchema } from 'src/api/endpoints/contentHub';

import { publicGateway } from '../../../config';

export const fetchPublicPageBySlug = async (
  slug: string
): Promise<ContentHubObjectSchema> => {
  const response = await publicGateway(
    process.env.REACT_APP_DOCUMENTS_API as string
  ).get(`/public/pages/slug/${slug}`);

  return response.data;
};
